/**
 * Opening a record a conversation shows, inside the conversation (owner 2026-10-31: "each card in the conversation
 * should have detailed view when there is underlying db record created and there is dedicated screen in detailed
 * view"). Only a surface that hosts the records panel provides an opener (`EntityOpenerProvider`: the simple view's
 * records column, the detailed conversation page's side panel); without one, cards show no Open control — a drawer or a
 * debug chat has nowhere to show the record.
 */
import type { ConversationEntityRef } from '@confluent/shared/lib/conversation-ui/entity-refs';
import { createContext, useContext } from 'react';

export type EntityPointer = Pick<ConversationEntityRef, 'entity' | 'id'>;

export interface EntityOpener {
  /** The record's type has a panel (or, a member's thread, a place to open) the person may see. */
  canOpen: (ref: EntityPointer) => boolean;
  open: (ref: EntityPointer) => void;
  /** The person's word for the type ("Strategy"), for lists and labels; null when it cannot be opened. */
  labelOf: (entity: string) => string | null;
}

export const EntityOpenerContext = createContext<EntityOpener | null>(null);

export function useEntityOpener(): EntityOpener | null {
  return useContext(EntityOpenerContext);
}
